// Formatting helpers for DSD Center, matching the rest of the SONAR suite.

const SYMBOL: Record<string, string> = { EUR: '€', USD: '$' }

export function symbol(currency: string): string {
  return SYMBOL[currency] ?? ''
}

/** Full grouped figure, e.g. €273,385 */
export function fmt(amount: number, currency: string): string {
  return symbol(currency) + Math.round(amount).toLocaleString('en-US')
}

/** Compact figure for axes/bars, e.g. €531k or €1.3M */
export function fmtCompact(amount: number, currency: string): string {
  const s = symbol(currency)
  const abs = Math.abs(amount)
  if (abs >= 1_000_000) return s + (amount / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
  if (abs >= 1_000) return s + Math.round(amount / 1_000) + 'k'
  return s + Math.round(amount)
}

/** Plain grouped integer (unit counts), e.g. 7,124 */
export function fmtUnits(n: number): string {
  return Math.round(n).toLocaleString('en-US')
}

/** "May-26" -> "May 2026". */
export function monthLabel(code: string): string {
  const [mon, yy] = code.split('-')
  if (!mon || !yy) return code
  return `${mon} 20${yy}`
}

/** Tailwind utility to render figures in JetBrains Mono with tabular alignment. */
export const MONO = "font-['JetBrains_Mono'] tabular-nums"
